var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 298,
    viewBox: "0 0 240 298",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 8C40 3.58172 43.5817 0 48 0H108C112.418 0 116 3.58172 116 8V98C116 102.418 112.418 106 108 106H48C43.5817 106 40 102.418 40 98V8ZM0 118C0 113.582 3.58172 110 8 110H48C52.4183 110 56 113.582 56 118V180C56 184.418 52.4183 188 48 188H8C3.58172 188 0 184.418 0 180V118ZM68 110C63.5817 110 60 113.582 60 118V180C60 184.418 63.5817 188 68 188H108C112.418 188 116 184.418 116 180V118C116 113.582 112.418 110 108 110H68ZM128 220C123.582 220 120 223.582 120 228V290C120 294.418 123.582 298 128 298H168C172.418 298 176 294.418 176 290V228C176 223.582 172.418 220 168 220H128ZM48 192C43.5817 192 40 195.582 40 200V290C40 294.418 43.5817 298 48 298H108C112.418 298 116 294.418 116 290V200C116 195.582 112.418 192 108 192H48ZM128 48C123.582 48 120 51.5817 120 56V208C120 212.418 123.582 216 128 216H232C236.418 216 240 212.418 240 208V56C240 51.5817 236.418 48 232 48H128Z",
    fill: "url(#paint0_linear_410_49590)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_410_49590",
    x1: 0.556299,
    y1: -0.00000812091,
    x2: 310.954,
    y2: 147.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7FBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5045"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/Union.835c8a8dbcf24b5fab4046046042bee4.svg";
export { ForwardRef as ReactComponent };